<template>

  <div class="app-wrapper">

    <!-- 左侧菜单 -->

    <div class="sidebar-container">

      <div class="logo-container">

        <span class="logo-text">智链商序管理后台</span>

      </div>

      <sidebar />

      <div class="sidebar-bottom-image">

        <img src="~@/assets/nav_left_bottom_img.png" alt="decoration">

      </div>

    </div>

    

    <!-- 右侧内容区 -->

    <div class="main-container">

      <div class="header">

        <div class="header-shine" aria-hidden="true" />

        <navbar />

      </div>

      

      <div class="app-main">

        <router-view />

      </div>

    </div>

  </div>

</template>



<script>

import Navbar from './components/Navbar'

import Sidebar from './components/Sidebar'



export default {

  name: 'Layout',

  components: {

    Navbar,

    Sidebar

  },

}

</script>



<style lang="scss" scoped>

@import '@/styles/variables.scss';



.app-wrapper {

  display: flex;

  height: 100vh;

  width: 100%;

  overflow: hidden;

  

  .sidebar-container {

    width: 180px;

    height: 100%;

    background: linear-gradient(180deg, $brand-primary-deep 0%, $brand-primary-dark 42%, $brand-primary 100%);

    border-right: 1px solid rgba(255, 255, 255, 0.06);

    box-shadow: 4px 0 24px rgba(7, 30, 40, 0.18);

    transition: width 0.28s;

    position: relative;

    z-index: 10;

    overflow-y: auto;

    display: flex;

    flex-direction: column;



    &::before {

      content: '';

      position: absolute;

      inset: 0;

      background:

        radial-gradient(ellipse 80% 40% at 0% 0%, rgba(16, 168, 129, 0.12), transparent 55%),

        radial-gradient(ellipse 60% 30% at 100% 100%, rgba(26, 95, 122, 0.2), transparent 50%);

      pointer-events: none;

    }

    

    .logo-container {
      position: relative;
      z-index: 1;
      min-height: 56px;
      display: flex;
      align-items: center;
      justify-content: center;
      padding: 10px 12px;
      background: linear-gradient(180deg, rgba(255, 255, 255, 0.08) 0%, rgba(255, 255, 255, 0.02) 100%);
      border-bottom: 1px solid rgba(255, 255, 255, 0.1);

      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 16px;
        right: 16px;
        height: 2px;
        background: linear-gradient(90deg, transparent, $brand-secondary, transparent);
        opacity: 0.45;
      }

      .logo-text {
        color: #fff;
        font-size: 13px;
        font-weight: 600;
        line-height: 1.45;
        text-align: center;
        letter-spacing: 0.5px;
      }
    }

    

    .sidebar-bottom-image {

      position: relative;

      z-index: 1;

      margin-top: auto;

      width: 100%;

      text-align: right;

      

      img {

        width: 55%;

        display: inline-block;

        margin-right: 0;

        opacity: 0.18;

        filter: hue-rotate(40deg) saturate(0.6);

      }

    }

  }

  

  .main-container {

    flex: 1;

    display: flex;

    flex-direction: column;

    overflow: hidden;

    background: $page-bg;

    

    .header {

      height: 56px;

      position: relative;

      overflow: hidden;

      z-index: 1;

      background: linear-gradient(135deg, $brand-primary-dark 0%, $brand-primary 52%, $brand-primary-light 100%);

      box-shadow: 0 2px 16px rgba(15, 61, 79, 0.28);



      .header-shine {

        position: absolute;

        inset: 0;

        background:

          linear-gradient(90deg, rgba(255, 255, 255, 0.06) 0%, transparent 35%, transparent 65%, rgba(16, 168, 129, 0.1) 100%),

          radial-gradient(ellipse 50% 120% at 85% -20%, rgba(16, 168, 129, 0.22), transparent 60%);

        pointer-events: none;

      }

    }

    

    .app-main {

      flex: 1;

      overflow: auto;

      padding: 20px 24px;

      background: $page-bg-gradient;

    }

  }

}

</style>


